import {Component, computed, inject, input, OnDestroy, OnInit, signal} from '@angular/core';
import {ControlContainer, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {LightbulbIcon, LucideAngularModule, MessageSquareLockIcon} from 'lucide-angular';
import {Subject, takeUntil} from 'rxjs';
import {StringFieldComponent} from '@shared/form/string/string-field/string-field.component';
import {HostForm} from '@domain/host/component/form/host-editor/host-editor';
import {HostContact, HostDTO} from '@domain/host/host.dto';
import {EmailFieldComponent} from '@shared/form/string/email-field/email-field.component';
import {ToggleSwitchFieldComponent} from '@shared/form/boolean/toggle-switch-field/toggle-switch-field.component';
import {
  HostContactPrivacyNote
} from '@domain/host/component/host-contact-privacy-note/host-contact-privacy-note.component';

@Component({
  selector: 'app-host-contact-editor',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslocoDirective,
    LucideAngularModule,
    StringFieldComponent,
    EmailFieldComponent,
    ToggleSwitchFieldComponent,
    HostContactPrivacyNote
  ],
  providers: [],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, {skipSelf: true})
    }
  ],
  templateUrl: './host-contact-editor.component.html'
})
export class HostContactEditorComponent implements OnInit, OnDestroy {

  private readonly controlContainer = inject(ControlContainer);

  public readonly form = computed(() => this.controlContainer.control as unknown as HostForm);
  public readonly contactForm = computed(() => this.form().controls.contact);
  public readonly formValue = signal<HostContact | null>(null);
  public readonly host = input.required<HostDTO>();
  public readonly newEmail = computed(() => this.host().newEmail ?? null);

  public readonly showNewEmailField = signal(false);

  public readonly icons = {
    idea: LightbulbIcon,
    message: MessageSquareLockIcon
  };

  private readonly destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.formValue.set(this.contactForm().value);
    this.contactForm().valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(value => this.formValue.set(value));
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public toggleShowNewEmail(): void {
    this.showNewEmailField.update(show => !show);
  }
}
